import React from 'react';
import { Text, VStack } from '@chakra-ui/react';
import { localise } from '../../../../services/lang/lang';
import { useUnsavedChanges } from '../../UnsavedChanges/UnsavedChangesProvider';
import ModalBackButton from '../../Modal/ModalBackButton';
import { makeMed4 } from '../../../../styles/textStyles';
import { useTokens } from '../../../../context/TokenProvider';
import EditContactWrapper from './EditContactWrapper';
import RenderIfElse from '../../RenderIf/RenderIfElse';
import AddContactWrapper from './AddContactWrapper';
const ContactDetailContent = ({ contact, isAdd, canEdit, onBack, onAddEditContact, inspectionId, }) => {
    const tokens = useTokens();
    const { attemptNavigate } = useUnsavedChanges();
    return (React.createElement(VStack, { align: "stretch", spacing: tokens.Spacing03 },
        React.createElement(ModalBackButton, { onClick: () => attemptNavigate(onBack), alignSelf: "flex-start" },
            React.createElement(Text, { sx: makeMed4(tokens) }, localise('BACK'))),
        React.createElement(RenderIfElse, { condition: isAdd && !contact, then: React.createElement(AddContactWrapper, { variant: "add-sidebar", onAddContact: onAddEditContact, inspectionId: inspectionId }), else: React.createElement(EditContactWrapper, { isShare: false, contact: contact, variant: "edit-sidebar", onEditContact: onAddEditContact, canEdit: canEdit }) })));
};
export default ContactDetailContent;
